module.exports = "https://files.cnvos.lb.djnd.si/static/images/mladina.png?4597c3ca063986a45f09e7c7ef1a697f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/mladina.png
// module id = 123
// module chunks = 1 2